var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header-component',{on:{"handleDrawer":_vm.handleDrawer}}),_c('sidebar-component',{attrs:{"drawer":_vm.drawer}}),_c('v-main',[_c('router-view')],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }